export const CLASSIFICATION = {
  EMPLOYMENTS: 'employment/type',
  LENDER: 'lender',
  WALLETS: 'payments/wallet/types',
  MOBILE_OPERATORS: 'mobile/operators',
};
